export function useSlugs() {
   const toSlug = (target: string) => target.trim().toLowerCase().replace(/\s+/g, "-")

   return {
      toSlug,
   }
}
